module.exports = __webpack_public_path__ + "static/img/weapp-header-dark.86cbbc15.png";